import React from 'react';
import { useRouter } from 'next/router';
import { Box } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

import { CartCheckoutActionsProvider } from 'journey/cart/providers';
import { useProductDetails } from 'journey/productDetails/provider';
import {
  IfpEligibilityCheckSteps,
  WearableEligibilityCheckSteps,
} from 'journey/productDetails/typings';
import { extractFirstValue } from 'shared/utils';
import { useWearableDevice } from '../../hooks';
import EligibilityCheckInformation from '../PlanOptions/components/EligibilityCheckInformation';
import WearableEligibilityCheckButton from '../WearableEligibilityActionLayerContent/component/WearableEligibilityCheckButton';
import { AddToCartButton, IfpEligibilityCheckButton } from './components';

const AddToCartSection = () => {
  const router = useRouter();
  const deviceId = extractFirstValue(router.query.offerId);
  const { ifpEligibility, wearableEligibility, selectedDevice } =
    useProductDetails();
  const { isWearableEligibilityCheckRequired } = useWearableDevice();

  const { activeStep, isCheckRequired: isIfpEligibilityCheckRequired } =
    ifpEligibility;
  const { activeStep: wearableActiveStep, isCheckRequired } =
    wearableEligibility;
  const showCheckEligibilityButton =
    isIfpEligibilityCheckRequired &&
    activeStep !== IfpEligibilityCheckSteps.AddToCart;

  const showWearableCheckEligibilitySection =
    isWearableEligibilityCheckRequired &&
    isCheckRequired &&
    wearableActiveStep !== WearableEligibilityCheckSteps.AddToCart;

  const showAddToCartButton = !(
    showCheckEligibilityButton || showWearableCheckEligibilitySection
  );

  const { stock } = selectedDevice;
  const isDisabled =
    stock?.warehouseStatus !== 'IN_STOCK' && stock?.storeStatus !== 'IN_STOCK';

  return (
    <div>
      <LinkRegion regionId={`productDetails.${deviceId}`}>
        {showWearableCheckEligibilitySection ? (
          <>
            <Box pt="s2">
              <EligibilityCheckInformation />
            </Box>
            <Box mb="s5">
              <WearableEligibilityCheckButton disabled={isDisabled} />
            </Box>
          </>
        ) : null}
        <Box mb="s5">
          {showCheckEligibilityButton ? (
            <IfpEligibilityCheckButton disabled={isDisabled} />
          ) : null}
          {showAddToCartButton ? (
            <CartCheckoutActionsProvider>
              <AddToCartButton />
            </CartCheckoutActionsProvider>
          ) : null}
        </Box>
      </LinkRegion>
    </div>
  );
};

export default AddToCartSection;
